// api接口文件
var SERVER_DOMAIN = window.location.host;
var SERVER_HOST = window.location.protocol + '//' + SERVER_DOMAIN+'/api';
// if (SERVER_HOST.indexOf('localhost')>=0) {
//   SERVER_HOST = '/api';
// }npm
const SERVER_HOST_MANAGER = SERVER_HOST+'/';
// const SERVER_HOST_MANAGER = 'http://dev.hs.cxhwh88.com/'; // 正式
// const SERVER_HOST_MANAGER = 'http://dev.huishou.cxhwh88.com/'; // 测试
const API = {
  user: {
    login: {   //登录
      url: SERVER_HOST_MANAGER + 'doLogin',
      method: 'POST'
    },
    password: {   //修改密码
      url: SERVER_HOST_MANAGER + 'change/password',
      method: 'POST'
    },
    appUserDetail: {   //详情
      url: SERVER_HOST_MANAGER + 'appUserDetail',
      method: 'GET'
    },
    refreshpwd: {   //重置用户密码
      url: SERVER_HOST_MANAGER + 'refreshpwd',
      method: 'POST'
    },
  },
  drawgoodss: {
    list: {   //商品列表
      url: SERVER_HOST_MANAGER + 'drawgoodss/list',
      method: 'POST'
    },
    classifyList: {   //下拉列表
      url: SERVER_HOST_MANAGER + 'drawgoodss/classifyList',
      method: 'POST'
    },
    detail: {   //按id查询详情
      url: SERVER_HOST_MANAGER + 'drawgoodss/detail',
      method: 'GET'
    },
    update: {   //更新POST /drawgoodss/updateBatch
      url: SERVER_HOST_MANAGER + 'drawgoodss/update',
      method: 'POST'
    },
    updateBatch: {   //批量更新
      url: SERVER_HOST_MANAGER + 'drawgoodss/updateBatch',
      method: 'POST'
    },
  },
  //文件管理
  attachs:{
    delete:{  //根据id删除图片
      url: SERVER_HOST_MANAGER + 'attachs/delete',
      method: 'GET'
    },
    list:{  //商品
      url: SERVER_HOST_MANAGER + 'attachs/list',
      method: 'POST'
    },
    sortByBizId:{  //根据List ID 排序
      url: SERVER_HOST_MANAGER + 'attachs/sortByBizId',
      method: 'POST'
    },
    detailLastByBizId:{  //根据业务id查询图片id
      url: SERVER_HOST_MANAGER + 'attachs/detailLastByBizId',
      method: 'GET'
    },
  },
   //文件上传
   file:{
    upload:{  //图片上传
      url: SERVER_HOST_MANAGER + 'file/upload',
      method: 'POST'
    },
    reUpload:{  //图片上传替换
      url: SERVER_HOST_MANAGER + 'file/reUpload',
      method: 'POST'
    },
    uploadZoom:{  //缩略图片上传
      url: SERVER_HOST_MANAGER + 'file/uploadZoom',
      method: 'POST'
    },
    getStringBizId:{  //生成id
      url: SERVER_HOST_MANAGER + 'file/getStringBizId',
      method: 'GET'
    },
    uploadMulti:{  //多文件上传
      url: SERVER_HOST_MANAGER + 'file/uploadMulti',
      method: 'POST'
    },
  },
  // 权限菜单
  menus: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'menus/list',
      method: 'POST'
    },
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'menus/add',
      method: 'POST'
    },
    all: {   //获取管理员
      url: SERVER_HOST_MANAGER + 'menus/all',
      method: 'POST'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'menus/delete',
      method: 'POST'
    },
    detail: {   //根据id获取详情
      url: SERVER_HOST_MANAGER + 'menus/detail',
      method: 'GET'
    },
    update: {   //修改
      url: SERVER_HOST_MANAGER + 'menus/update',
      method: 'POST'
    },
  },
  sysusers: {
    myInfo:{  //获取个人信息POST /sysusers/add
      url: SERVER_HOST_MANAGER + 'sysusers/myInfo',
      method: 'GET'
    },
    list:{  //列表
      url: SERVER_HOST_MANAGER + 'sysusers/list',
      method: 'POST'
    },
    userList:{  //列表
      url: SERVER_HOST_MANAGER + 'sysusers/userList',
      method: 'POST'
    },
    add:{  //添加
      url: SERVER_HOST_MANAGER + 'sysusers/add',
      method: 'POST'
    },
    delete:{  //删除
      url: SERVER_HOST_MANAGER + 'sysusers/delete',
      method: 'POST'
    },
    detail:{  //详情
      url: SERVER_HOST_MANAGER + 'sysusers/detail',
      method: 'GET'
    },
    update:{  //更新
      url: SERVER_HOST_MANAGER + 'sysusers/update',
      method: 'POST'
    },
    updateStatus:{  //更新POST /sysusers/
      url: SERVER_HOST_MANAGER + 'sysusers/updateStatus',
      method: 'POST'
    },
    roleList:{  //角色下拉列表
      url: SERVER_HOST_MANAGER + 'sysusers/roleList',
      method: 'GET'
    },
    disable:{  //角色下拉列表
      url: SERVER_HOST_MANAGER + 'sysusers/disable',
      method: 'POST'
    }
  },
  goodsexchanges: {
    list: {   //用户列表
      url: SERVER_HOST_MANAGER + 'goodsexchanges/list',
      method: 'POST'
    },
    financeExamine: {   //财务审核
      url: SERVER_HOST_MANAGER + 'goodsexchanges/financeExamine',
      method: 'POST'
    },
    serviceExamine: {   //客服审核
      url: SERVER_HOST_MANAGER + 'goodsexchanges/serviceExamine',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'goodsexchanges/detail',
      method: 'GET'
    },
    export: {   //导出
      url: SERVER_HOST_MANAGER + 'goodsexchanges/export',
      method: 'POST'
    },
  },
  roles: { // 角色接口
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'roles/list',
      method: 'POST'
    },
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'roles/add',
      method: 'POST'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'roles/update',
      method: 'POST'
    },
    status: {   //变更角色状态
      url: SERVER_HOST_MANAGER + 'roles/status',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'roles/detail',
      method: 'GET'
    },
    delete: {   //
      url: SERVER_HOST_MANAGER + 'roles/delete',
      method: 'POST'
    },
  },
  syspermissions: { // 系统权限接口
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'syspermissions/list',
      method: 'POST'
    },
    addbatch: {   //多个添加
      url: SERVER_HOST_MANAGER + 'syspermissions/addbatch',
      method: 'POST'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'syspermissions/update',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'syspermissions/detail',
      method: 'GET'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'syspermissions/delete',
      method: 'GET'
    },
  },
  withdrawApplies: {
    list: {
      url: SERVER_HOST_MANAGER + 'withdrawApplies/list',
      method: 'POST'
    },
    confirm: {
      url: SERVER_HOST_MANAGER + 'withdrawApplies/confirm',
      method: 'POST'
    },
    refuse: {
      url: SERVER_HOST_MANAGER + 'withdrawApplies/refuse',
      method: 'POST'
    },
    record: {
      url: SERVER_HOST_MANAGER + 'accountBalanceDetails/listForAdmin',
      method: 'POST'
    }
  },
  payoutStrategies: {
    list: {
      url: SERVER_HOST_MANAGER + 'payoutStrategies/list',
      method: 'POST'
    },
    update: {
      url: SERVER_HOST_MANAGER + 'payoutStrategies/update',
      method: 'POST'
    }
  }

};
module.exports = API;




// WEBPACK FOOTER //
// ./src/common/constants.js